import { lazyGetFolderMenuOptionsSections } from 'owa-mail-ribbon-sections/lib/sections';
import type { ReadOnlyRibbonControlDefProps } from 'owa-mail-ribbon-utils';
import type { MailboxInfo } from 'owa-client-types';
import { setMenuDefinition } from '../../mutatorActions/setMenuDefinition';

export const onFolderMenuOptionsMenuClicked = (
    props: ReadOnlyRibbonControlDefProps,
    mailboxInfo: MailboxInfo
): void => {
    lazyGetFolderMenuOptionsSections.import().then(getFolderMenuOptionsSections => {
        setMenuDefinition(
            'FolderMenuOptionsMenuDefinitionStore',
            undefined /* projectionTabId */,
            () => {
                return {
                    sections: getFolderMenuOptionsSections(props, mailboxInfo),
                };
            }
        );
    });
};
